import LaasImg from "public/pocCloud/lab-as-a-service.png";
import { ListWithLabel } from "@/components/list";

export const INTRO_CONSTANTS = {
  title: "Lab-as-a-Service, Reimagined by OneMind",
  description: [
    "Unlock advanced IT lab environments for modern cloud computing - no hardware required. OneMind’s Lab-as-a-Service (LaaS) delivers fully managed, cloud-based labs designed for testing, training, development, and simulation. Whether you're validating network architectures, conducting hands on IT training, or testing software at scale, we make it effortless.",
    "Eliminate infrastructure headaches and accelerate innovation with real-world lab experiences powered by automation —delivered on demand.",
  ],
  children: (
    <ListWithLabel
      points={[
        {
          label: "Fully Managed Cloud Lab Infrastructure",
          text: "Provision labs instantly with zero setup or maintenance overhead using flexible architecture.",
        },
        {
          label: "On-Demand Scalability",
          text: "Spin up training labs, dev/test environments, or simulations as needed across AWS.",
        },
        {
          label: "Cost-Effective & Realistic",
          text: "Access enterprise-grade environments without capital investment—built for hands on learning and experimentation.",
        },
      ]}
    />
  ),
  image: LaasImg,
};
